import { Image } from '@/shared/Components';
import { PATH } from '@/shared/constants';

const SearchFace = () => {
  return (
    <Image
      alt="검색 이모지"
      data-testid="search-face"
      sizes="16px"
      src={`${PATH.MEDIA_YOZM_IMAGE}/search_face.png`}
      unoptimized
    />
  );
};

export default SearchFace;
